<script>
	import KpContent from "./KpContent.svelte"
					
  
  import { redirect } from "../../pager";
  import { fade } from "svelte/transition"; 
  import Navigationbar from "../../components/Navigationbar.svelte";
  //liblary 
  import { session } from "../../components/js/notif.js";
  let settings;
  session.subscribe((value) => {
    settings = value;
  });
  

  //scroll to top every page load
  window.scroll({
    top: 0,
    left: 0,
    behavior: "smooth",
  });
 
</script>
<svelte:head>
  <title>Kebijakan Privasi Dekatan</title>
</svelte:head>
<main transition:fade  class="container pt-16 mx-auto mb-5 px-2" style="">
   
  <div class="max-w-4xl mx-auto px-3 py-5 bg-white rounded-lg">
    
  <div class="font-bold justify-center mb-2">
    <img on:click={()=>redirect('/')}
      src="./assets/logo/logo.svg" width="274" height="64"
      alt="logo"
      class="h-20 bg-white rounded-lg shadow-lg py-2 cursor-pointer" />
  </div>
    <div class="mx-auto p-10 text-sm text-justify">
   <KpContent/>
    </div>
  </div>
</main> 
